import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { ExtractionReviewViewMode } from 'src/types/fieldExtraction';

export interface UserPreferences {
  data: {
    stackSearchFilterId?: string;
    fieldStackFilterId?: string;
    documentStackFilterId?: string;
    extractionReviewViewMode?: ExtractionReviewViewMode | null;
    guidelineBuddyVerificationToken?: string | null;
  };
}

const getUserPreferences: QueryFunction<
  UserPreferences,
  ['/user/preferences']
> = async () => {
  if (isMockServices()) return await mock(_mockUserPreferences);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UserPreferences>(
    '/shared/user/preferences',
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to get user preferences');
};

const _mockUserPreferences: UserPreferences = {
  data: {
    stackSearchFilterId: 'mock-stack-search-filter-id',
    fieldStackFilterId: 'mock-field-stack-filter-id',
    documentStackFilterId: 'mock-document-stack-filter-id',
    extractionReviewViewMode: 'form',
    guidelineBuddyVerificationToken: 'mock-guideline-buddy-token',
  },
};

export { _mockUserPreferences };
export default getUserPreferences;
